import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay/classic';
import get from 'lodash.get';
import PrimaryButton from 'dibs-elements/dist/Button/Primary';
import 'dibs-elements/dist/Button/buyer/Primary.css';
import { loadSourcingModal, ORIGIN_HOLD, ORIGIN_SOLD } from 'dibs-buyer-layout/src/utils/tradeOnboardingHelper';

import style from './SourcingCta.scss';
import { sourcingCta as copy } from '../../../../../json/copy/pdp.json';

class SourcingCta extends Component {
    constructor() {
        super();
        this.loadOnboardingModule = this.loadOnboardingModule.bind(this);
    }

    loadOnboardingModule() {
        const email = get(this.props.user, 'profile.email');
        const item = this.props.item;
        const isSold = get(item, 'isSold');
        const isOnHold = get(item, 'isOnHold');
        const itemReferenceNumber = get(item, 'dibsReference');
        let requestOrigin = '';

        if (isSold) {
            requestOrigin = ORIGIN_SOLD;
        } else if (isOnHold) {
            requestOrigin = ORIGIN_HOLD;
        }

        loadSourcingModal({
            buyerEmail: email,
            requestOrigin,
            itemReferenceNumber,
            trackingLabel: 'cta - pdp - sidebar',
        });
    }

    render() {
        return (
            <div className={style.wrapper}>
                <div className={style.headline}>{copy.headline}</div>
                {copy.content}
                <PrimaryButton
                    className={style.cta}
                    dataTn="item-actions-request-sourcing"
                    onClick={this.loadOnboardingModule}
                >
                    {copy.cta}
                </PrimaryButton>
            </div>
        );
    }
}

SourcingCta.propTypes = {
    user: PropTypes.object,
    item: PropTypes.object,
};

export default Relay.createContainer(SourcingCta, {
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                profile {
                    email
                }
            }
        `,
        item: () => Relay.QL`
            fragment on Item {
                isSold
                isOnHold
                dibsReference
            }
        `,
    },
});



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/SourcingCta/SourcingCta.jsx